/**
  * 与 Native APP 数据交互的简单封装
  *
  * 参考: https://juejin.im/post/5abca877f265da238155b6bc#comment
  *
  * Example:
  *   1、调用 Native 的 getDeviceInfo 方法:
  *     window.JSBridge.invoke({
  *       bridgeName: 'getDeviceInfo',
  *       data: {},
  *       callback: (res) {
  *         console.log('res =>>', res);
  *       }
  *     });
 *  2、绑定 Native 方法，由客户端主动发起 消息通知到web
 *  // listerEventsName 不自动做自增，每次添加重复即替换。
 *  window.JSBridge.invoke({
 *    bridgeName: 'openPhotoChoice',
 *    data: 3 - this.imgList.length,
 *    listerEventsName: 'uploadFiles',
 *    listerEventsCallback: this.imgCallback, // 此为客户端调用H5的方法
 *  });
 */
import { getDeviceInfo, getQueryObject } from '@/utils';
import { getHeaderForApp } from '@/utils/js-bridge/utils';

(function JSBridge() {
  const device = getDeviceInfo();
  // 存储回调函数的对象
  const callbacks = {};
  let id = 0;

  window.JSBridge = {
    /**
     * 注册回调函数 & 调用 Native 的方法
     * @param bridgeName
     * @param data = {}
     * @param callback
     * @param listerEventsName
     * @param listerEventsCallback
     */
    invoke({ bridgeName, data = {}, callback: bridgeCallBack, listerEventsName = '', listerEventsCallback = null }) {
      if (!bridgeName) {
        console.warn('window.JSBridge.invoke() was miss bridgeName!');
        return;
      }

      const { sourceApp } = getHeaderForApp();
      const { source_app: sourceAppFromHref } = getQueryObject(window.location.href);
      const isFlutter = (sourceApp || sourceAppFromHref || '').toUpperCase() === 'FLUTTER';

      // 存储 callback
      id += 1;
      const cbKey = `${bridgeName}-${id}`;
      callbacks[cbKey] = bridgeCallBack;

      if (listerEventsName) {
        if (Array.isArray(listerEventsName)) {
          // eslint-disable-next-line no-restricted-syntax
          for (const item of listerEventsName) {
            console.log(item, '<<<<');
            window[item] = res => listerEventsCallback(item, res);
          }
        } else {
          window[listerEventsName] = listerEventsCallback;
        }
      }

      const params = {
        bridgeName,
        callbackKey: cbKey,
        data,
      };
      console.log('invoke params =>>', params, { ...(listerEventsName ? { [listerEventsName]: listerEventsCallback } : {}) });
      console.log('invoke isFlutter =>>', isFlutter);

      try {
        // 判断环境，获取不同的 nativeBridge
        if (device.isAndroid) {
          console.log('Android', bridgeName);
          // Android 只能接收字符串
          if (isFlutter) {
            console.log(1, window[bridgeName]);
            console.log(2, window[bridgeName].postMessage);
            window[bridgeName].postMessage(JSON.stringify({ data: params }));
          } else {
            window.h5_Android[bridgeName](JSON.stringify(params));
          }
        } else if (device.isIOS) {
          console.log('IOS', bridgeName);
          const postMessageParams = isFlutter ? JSON.stringify({ data: params }) : params;
          console.log('ios', postMessageParams);
          console.log(1, window.webkit?.messageHandlers);
          console.log(2, window.webkit?.messageHandlers[bridgeName]);
          console.log(3, window.webkit?.messageHandlers[bridgeName].postMessage);
          window.webkit.messageHandlers[bridgeName].postMessage(postMessageParams);
        } else {
          console.warn(`Not support native's ${bridgeName} func!`);
        }
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * 移除 已注册的回调函数
     *
     * @param {*} callbackKey
     */
    remove(callbackKey) {
      console.log('callbackKey =>>', callbackKey);
      delete callbacks[callbackKey];
    },

    /**
     * 接收 Native 的回调 & 处理实际要回调的函数
     *
     * @param {*} { callbackKey, data = {} }
     */
    receiveMessage({ bridgeName = '', callbackKey = '', data = {} }) {
      console.log(`bridgeName =>> ${bridgeName}, callbackKey =>> ${callbackKey}, `);

      if (callbackKey) {
        // 找到相应句柄 & 执行调用 & 删除句柄
        if (callbacks[callbackKey]) {
          callbacks[callbackKey](data);
          this.remove(callbackKey);
        } else {
          console.warn(`Not fund callbackKey[${callbackKey}]`);
        }
      }
    },

    /**
     * 获取 当前暂存的回调函数
     *
     * @returns
     */
    $_getCallbacks() {
      return callbacks;
    },
  };
}());
